import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'

const VerificationWarningModal = ({ distributeStore }) => (
    <Modal
        show={distributeStore.verificationWarningModalVisible}
        onClose={distributeStore.hideVerificationWarningModal}
    >
        <div className="delete-modal-content">
            <i className="fal fa-circle-exclamation" style={{ fontSize: 36, color: 'red' }} />

            <h2>{i18n.t('distributionVerificationWarningModal.title')}</h2>

            <p dangerouslySetInnerHTML={{ __html: i18n.t('distributionVerificationWarningModal.subtitle') }} />
        </div>

        <ModalFooter>
            <div className="delete-modal-footer-content">
                <Button cssClass="regular error" onClick={distributeStore.hideVerificationWarningModal}>
                    {i18n.t('cancel')}
                </Button>

                <Button cssClass="regular primary" onClick={distributeStore.verificationWarningSchedule}>
                    {i18n.t('distributionScheduleEmailModal.title')}
                </Button>
            </div>
        </ModalFooter>
    </Modal>
)

export default observer(VerificationWarningModal)
